"use strict";

(function () {
  'use strict';

  angular.module('lr.Settings').controller('SettingsCtrl', settingsCtrl);
  settingsCtrl.$inject = ['DeviceAdminFactory', 'User', 'EventSettingsFactory', 'AccountSetttingsService', 'automationEventTypes', '$lrNotifier'];
  /* @ngInject */

  function settingsCtrl(DeviceAdminFactory, User, EventSettingsFactory, AccountSetttingsService, automationEventTypes, $lrNotifier) {
    /* jshint validthis: true */
    var vm = this;
    vm.activate = activate;
    vm.title = 'settingsCtrl';
    vm.eventTypesFilter = automationEventTypes;
    vm.eventSettings = EventSettingsFactory;

    if (User.isAuthenticated()) {
      activate();
    }

    vm.updateAccountSettings = function () {
      AccountSetttingsService.updateAccountSettings(vm.accountSettings).then(function (data) {
        $lrNotifier.content('Settings Update Successfully').show();
      }, function (error) {
        console.log(error);
      });
    };

    vm.init = function () {
      AccountSetttingsService.getAccountSettings().then(function (data) {
        console.log('data', data);
        vm.accountSettings = data.data;
      }, function (error) {
        console.log(error);
      });
    };

    vm.init(); ////////////////

    function activate() {
      vm.deviceAdmin = DeviceAdminFactory.generate({
        adminCustDataID: User.getToken().AdminCustDataID
      });
      vm.deviceAdmin.getPropertiesForPartner();
    }
  }
})();